import React, { useEffect, useRef, useState } from 'react';
import Menu from '../../components/sturtural/Menu';
import { BASE_API } from '../../api/Globals';
import { helpHttp } from '../../helpers/helpHttp';
//import useHelpHttp from '../../hooks/useHelpHttp';
import Loader from '../../components/sturtural/Loader';
import MessageDetail from '../../components/sturtural/MessageDetail';
import { Toolbar } from 'primereact/toolbar';
import { Button } from 'primereact/button';
import { Tag } from 'primereact/tag';
import { Dialog } from 'primereact/dialog';
import { useNavigate } from 'react-router-dom';
import { Checkbox } from 'primereact/checkbox';
import { InputText } from 'primereact/inputtext';
import { Toast } from 'primereact/toast';
import { Tooltip } from 'primereact/tooltip';
import { storage } from '../../helpers/storage';

const PendientesTablets = () => {
    const navigate = useNavigate();

    const [db, setDb] = useState(null);
    const [alumnosPendientes, setAlumnosPendientes] = useState(null)
    const [filtro, setFiltro] = useState('')
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(false);
    const [cancelacion, setCancelacion] = useState(false);
    const [cancelacionids, setCancelacionIds] = useState(false);
    const [displayDialog_cancelacion, setDisplayDialog_cancelacion] = useState(false);
    const [loading_cancelacion, setLoading_cancelacion] = useState(false);

    const [motivo, setMotivo] = useState(null);
    const [loading_motivo, setLoadingMotivo] = useState(null);

    const [firma, setFirma] = useState(false);

    const perfil = storage.get('perfilid');

    const toast = useRef(null)

    useEffect(() => {
        if (db === null) {
            setDb(alumnosPendientes)
            console.log(alumnosPendientes)
        }
    }, [alumnosPendientes])

    useEffect(() => {
        if (![1, 2, 5, 13, 16].includes(parseInt(perfil))) {
            return navigate('/login');
        }
    }, [perfil]);

    let url = `${BASE_API}BusquedaAlumnos/getAlumnosPendientes`;
    useEffect(() => {

        const arrAlumno = {
            "IdAlumno": 0,
            "Nombre": "",
            "ApellidoPaterno": "",
            "ApellidoMaterno": "",
            "Nivel": "",
            "Curp": "",
            "Turno": "",
            "Grado": "",
            "Grupo": "",
            "Escuela": "",
            "CCT": "",
            "Estatus": "",
            "Municipio": "",
            "Localidad": "",
            "IdEstatus": 1,
            "IdEncEntrega": 0,
            "IdDetEntrega": 0,
            "Genero": "",
            "IdTutor": 0,
            "IdTienda": storage.get('IdTienda'),
            "IdTipoVale": 0,
            "Pagina": 1,
            "OrderBy": "",
            "NombreCompleto": ""
        }

        setLoading(true);
        helpHttp().post(url, {
            body: arrAlumno,
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                "Accept": "application/json",
                'Authorization': `Bearer ${storage.get('token')}`
            },
        }).then(res => {
            if (!res.err) {
                let result = res.Result.map(items => {
                    let item = {
                        ...items,
                        Seleccionado: false
                    }
                    return item
                });

                const idsremover = JSON.parse(localStorage.getItem('transactionIdAlumno')) || [];
                idsremover.forEach(element => {
                    result.filter((value, index, arr) => {
                        if (element.includes(value.IdAlumno.toString())) {
                            arr.splice(index, 1);
                            return true;
                        }
                        return false;
                    });
                });

                setAlumnosPendientes(result);
                setError(null);
            } else {
                alumnosPendientes(null);
                setError(res);
            }
            setLoading(false);
        });
    }, [url]);

    useState(() => {

    }, [alumnosPendientes])

    useEffect(() => {
        setLoadingMotivo(true);
        helpHttp().post(`${BASE_API}Entrega/CargaMotivoCancelacion`, {
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                "Accept": "application/json",
                'Authorization': `Bearer ${storage.get('token')}`
            },
        }).then(res => {
            if (!res.err) {
                setMotivo(res);
                setError(null);
            } else {
                setMotivo(null);
                setError(res);
            }
            setLoadingMotivo(false);
        });
    }, [url]);

    const handlerDisplayDialog_motivoCancelacion = (IdAlumno, IdEncEntrega) => {
        setCancelacion(true);
        setCancelacionIds({ IdAlumno, IdEncEntrega });
    }

    const handleDisplayDialogConfirm_cancelarEntrega = (IdMotivoCancelacion) => {

        if (IdMotivoCancelacion !== cancelacionids.IdMotivoCancelacion) {
            setCancelacionIds({ ...cancelacionids, IdMotivoCancelacion });
        }

        setDisplayDialog_cancelacion(true);
    }
    const dialogFooter_cancelacion = (
        <>
            <Button label="No" icon="pi pi-times" className="p-button-text" onClick={() => handleConfirm_no()} />
            <Button label="Sí" disabled={loading_cancelacion} icon={!loading_cancelacion ? "pi pi-check" : 'pi pi-spin pi-spinner'} className="p-button-text" onClick={() => handlerSubmit_cancelacion()} />
        </>
    );

    const hideDisplayDialogConfirm_cancelacion = () => {
        setDisplayDialog_cancelacion(false);
    }

    const handleConfirm_no = () => {
        hideDisplayDialogConfirm_cancelacion();
    }

    const handlerSubmit_cancelacion = () => {
        setLoading_cancelacion(true);
        const arrBody = {
            "IdEncEntrega": cancelacionids.IdEncEntrega,
            "IdTienda": storage.get('IdTienda'),
            "IdUsuario": storage.get('id'),
            "IdTutor": 0,
            "FechaCreacion": "",
            "Latitud": "",
            "Longitud": "",
            "IdEstatus": 3,
            "IdMotivoCancelacion": cancelacionids.IdMotivoCancelacion,
            "FechaModificacion": "",
            "IdUsuarioModificacion": 0,
            "MotivoCancelacion": "0",
            "alumnosId": [cancelacionids.IdAlumno],
            "OtroMotivoCancelacion": "",
            "IdAlumno": cancelacionids.IdAlumno,
            "IdTipoVale": 0,
            "JustificacionDeCancelacion": "0",
            "IdDocumento": 0
        }

        helpHttp().post(`${BASE_API}Entrega/CancelarEntregaPendiente`, {
            body: arrBody,
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                "Accept": "application/json",
                'Authorization': `Bearer ${storage.get('token')}`
            },
        }).then(res => {
            if (!res.err) {
                let _alumnos = db.filter(val => val.IdAlumno !== cancelacionids.IdAlumno);
                setDb(_alumnos);

                hideDisplayDialogConfirm_cancelacion();
                setCancelacion(false);
            } else {
                //setDb(null);
                //setError(res);
            }
            setLoading_cancelacion(false);
        });
    }

    const multientregaOnClick = () => {
        if (db !== null) {
            let seleccionado = db.filter((e) => e.Seleccionado === true)

            if (seleccionado.length !== 0) {
                window.localStorage.setItem('multientregaTabletsAlm', JSON.stringify(seleccionado))
                navigate('/multientrega-tablets');
            } else {
                toast.current.show({ severity: 'warn', summary: 'Aviso', detail: 'Debe de tener al menos a un alumno seleccionado.', life: 5000 });
            }
        } else {
            toast.current.show({ severity: 'warn', detail: 'Aviso', detail: 'No tiene alumnos pendientes.', detail: 5000 });
        }
    }

    const Search = () => {
        var text
        text = filtro;
        const arreglo = alumnosPendientes.filter(function (o) {
            return ["IdAlumno", "Nombre", "ApellidoPaterno", "ApellidoMaterno", "Curp", "NombreCompleto"].some(function (k) {
                if (o[k] !== null) {
                    return o[k].toString().indexOf(text) !== -1;
                }
            });
        });
        setDb(arreglo)
    }

    const leftToolbarTemplate = () => {
        return (
            <React.Fragment>
                <span className='p-input-icon-left' style={{width: '230px'}}>
                    <i className='pi pi-search' />
                    <InputText placeholder='Buscador por curp o nombre' className='w-full' value={filtro} onChange={(e) => setFiltro(e.target.value.toUpperCase())} />
                </span>
                <Button label='Buscar' className='p-button ml-3' onClick={() => Search()} />
                <Button label='Limpiar' className='p-button-outlined ml-3' onClick={() => { setDb(alumnosPendientes); setFiltro('') }} />
            </React.Fragment>
        )
    }

    return (
        <>
            <Toast ref={toast} />
            <Menu link='pendientes' />

            <div className="grid">
                <div className="col-12">
                    <div className="card">
                    <div><h3 style={{textAlign: 'center'}}>ESTUDIANTES PENDIENTES</h3></div>
                        <Toolbar left={leftToolbarTemplate} />
                        <h5 style={{textAlign:'end'}}> Total pendientes: {db && (db.length > 0 ? db.length : 0)}</h5>
                        {loading && <div><Loader /></div>}
                        {error && <MessageDetail color="error" mensaje={`Error ${error.status}: ${error.statusText}`} />}
                        {db && db.map((el, index) =>
                            <div className="col-12 lg:col-12 p-3 shadow-3 surface-card mb-2" key={index}>
                                <div className="p-3 border-round  flex align-items-center">
                                    <div className='mr-3'>
                                        <Checkbox checked={el.Seleccionado} onChange={event => {
                                            let checked = event.target.checked
                                            let arrayEstado = [];
                                            setDb(
                                                db.map(data => {
                                                    if (el.IdEncEntrega === data.IdEncEntrega) {
                                                        data.Seleccionado = checked
                                                    }

                                                    arrayEstado.push(data.Seleccionado)
                                                    let incluyeFalse = arrayEstado.includes(false);

                                                    return data
                                                })
                                            )
                                        }}></Checkbox>
                                    </div>
                                    <div>

                                        <span className="text-900 text-xl font-medium mb-2">{el.Curp} - {el.Nombre} {el.ApellidoPaterno} {el.ApellidoMaterno}</span>
                                        <p className="mt-1 mb-0 text-600 font-medium text-sm">Tutor: {el.ObjTutor.NombreCompletoTutor}</p>
                                        <p className="mt-1 mb-0 text-600 font-medium text-sm">Clave Sup: {el.CCT} Escuela: {el.Escuela}</p>
                                        <p className="mt-1 mb-0 text-600 font-medium text-sm">Municipio: {el.Municipio}</p>
                                        <p className="mt-1 mb-0 text-600 font-medium text-sm">Nivel: {el.Nivel.toLowerCase()} Grupo: {el.Grado} {el.Grupo}</p>


                                    </div>
                                    <div className="ml-auto grid" style={{marginRight: '30px'}}>                                      
                                        <div className='col-12 text-center'>
                                            <Tooltip target=".custom-target-icon" />
                                            <div style={{border: '1px solid #9b2f3e', width: '40px', height: '40px', borderRadius: '20px'}} onClick={() => handlerDisplayDialog_motivoCancelacion(el.IdAlumno, el.IdEncEntrega)} className="custom-target-icon col-12 inline-flex align-items-center justify-content-center cursor-pointer text-center" data-pr-tooltip='Remover' data-pr-position='top'>
                                                <i className="pi pi-trash" style={{fontSize: '20px', color: '#9b2f3e'}}></i>
                                            </div>                                     
                                        </div>
                                        
                                       {/*  <div className='col-12 text-center'>
                                            <Tag className="mr-2" severity="success" value={el.Nivel}></Tag>
                                            <Tag className="mr-2" value={`${el.Grado} ${el.Grupo}`}></Tag>
                                        </div> */}
                                    </div>
                                </div>
                            </div>
                        )}
                        <div id='btnSiguiente' className='text-right m-3'>
                            <Button className='p-button-rounded w-auto' label='Siguiente' onClick={() => multientregaOnClick()} />
                        </div>
                    </div>
                </div>
            </div>

            <Dialog header="MOTIVO DE CANCELACIÓN" visible={cancelacion} style={{ width: '95%' }} modal onHide={() => setCancelacion(false)}>
                <div className="grid">
                    {loading_motivo && <div><Loader /></div>}
                    {motivo && motivo.map((el, index) =>
                        <div className="col-12 lg:col-4 p-3 shadow-3 surface-card mb-2" style={{ 'borderLeft': '3px solid #FF0000', 'cursor': 'pointer' }} onClick={() => handleDisplayDialogConfirm_cancelarEntrega(el.IdMotivoCancelacion)} key={`m-${index}`}>
                            <div className="p-3 border-round  flex align-items-center">
                                <span className="text-900 text-xl font-medium mb-2">{el.MotivoCancelacion}</span>
                            </div>
                        </div>
                    )}
                </div>
            </Dialog>

            <Dialog visible={displayDialog_cancelacion} style={{ width: '450px' }} header="Confirmación" modal footer={dialogFooter_cancelacion} onHide={hideDisplayDialogConfirm_cancelacion}>
                <div className="flex align-items-center justify-content-center">
                    <i className="pi pi-exclamation-triangle mr-3" style={{ fontSize: '2rem' }} />
                    <span>¿Está seguro de ejecutar esta cancelación?</span>
                </div>
            </Dialog>

            <Dialog visible={firma} style={{ width: '100%', height: '100%' }} header="Confirmación" modal onHide={() => setFirma(false)}>

            </Dialog>
        </>

    );
}

export default PendientesTablets;